<template>
  <div>
      <div class="slider">
          <div class="left button" @click="userPrev">&#10094;</div>
          <div class="right button" @click="userNext">&#10095;</div>
          <div class="spinner"><font-awesome-icon class="fa-2x" spin :icon="faSpinner" /></div>
          <div class="imgbox animateleft" 
              :class="{ moveleft: resolve('A', 0), movecentre: resolve('A', 1), moveright: resolve('A', 2), infront: boxStates.A>=3 }" >
              <div class='img' :class="{ animate: kenburns }" :style="{ backgroundImage: aImg }">&nbsp;</div>
          </div>
          <div class="imgbox animateleft"
              :class="{ moveleft: resolve('B', 0), movecentre: resolve('B', 1), moveright: resolve('B', 2), infront: boxStates.B>=3 }" >
              <div class='img' :class="{ animate: kenburns }" :style="{ backgroundImage: bImg }">&nbsp;</div>
          </div>
          <div class="imgbox animateleft"
              :class="{ moveleft: resolve('C', 0), movecentre: resolve('C', 1), moveright: resolve('C', 2), infront: boxStates.C>=3 }" >
              <div class='img' :class="{ animate: kenburns }" :style="{ backgroundImage: cImg }">&nbsp;</div>
          </div>
      </div>
  </div>
</template>
<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import faSpinner from '@fortawesome/fontawesome-free-solid/faSpinner'

export default {
  components: {
    FontAwesomeIcon
  },

  props: {
    imagelist: {
      type: Array
    },

    auto: {
      type: Boolean
    },

    kenburns: {
      type: Boolean
    },

    random: {
      type: Boolean
    },

    delay: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      boxStates: { A: 0 + 0, B: 4, C: 2 },
      boxes: ['A', 'B', 'C'],
      interval: null,
      imageindex: 0,
      faSpinner,
      inhibitSlide: false,
      moveQ: [],
      aImg: '',
      bImg: '',
      cImg: '',
      iList: []
    }
  },
  mounted () {
    if (this.random) this.iList = [...this.shuffle(this.imagelist)]
    else this.iList = [...this.imagelist]

    const allPromises = this.iList.map(ii => this.preloadImage(ii.img))

    // wait at least delay secs
    if (this.delay > 0) {
      allPromises.push(new Promise(resolve => setInterval(() => resolve(), this.delay * 1000)))
    }

    Promise.all(allPromises).then(() => {
      this.setupInterval()
      this.previi()
      this.aImg = this.currImgUrl()
      this.nextii()
      this.bImg = this.currImgUrl()
      this.nextii()
      this.cImg = this.currImgUrl()
      this.previi()

      this.$root.isLoading = false
    })
  },

  methods: {
    preloadImage (src) {
      return new Promise((resolve) => {
        const i = new Image()
        i.onload = () => {
          resolve()
        }
        i.src = src
      })
    },

    shuffle (a) {
      const na = [...a]
      for (let i = na.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1))
        const tmp = na[i]
        na[i] = na[j]
        na[j] = tmp
      }
      return na
    },

    nextii () {
      this.imageindex =
        this.imageindex === this.iList.length - 1 ? 0 : this.imageindex + 1
    },

    previi () {
      this.imageindex =
        this.imageindex === 0 ? this.iList.length - 1 : this.imageindex - 1
    },

    currImgUrl () {
      return `url(${this.iList[this.imageindex].img})`
    },

    primebox (bi) {
      const c = this.boxes[bi]
      const url = this.currImgUrl()
      switch (c) {
        case 'A':
          this.aImg = url
          break
        case 'B':
          this.bImg = url
          break
        case 'C':
          this.cImg = url
          break
        default:
      }
      this.inhibitSlide = true
      setTimeout(() => {
        this.inhibitSlide = false
        this.processQueue()
      }, 1000)
    },

    processQueue () {
      if (this.moveQ.length === 0) return
      const m = this.moveQ.shift()
      if (m < 0) this.movePrev()
      else this.moveNext()
    },

    setupInterval () {
      if (!this.auto) return
      this.interval = setInterval(
        () => this.nextImage(),
        10000
      )
    },

    resolve (k, val) {
      return this.boxStates[k] % 3 === val
    },

    queueMove (dir) {
      this.moveQ.push(dir)
      if (this.moveQ.length === 2) this.moveQ.shift()
    },

    userNext () {
      if (this.inhibitSlide) this.queueMove(1)
      else this.moveNext()
    },

    userPrev () {
      if (this.inhibitSlide) this.queueMove(-1)
      else this.movePrev()
    },

    moveNext () {
      this.teardownInterval()
      this.nextImage()
      this.setupInterval()
    },

    movePrev () {
      this.teardownInterval()
      this.prevImage()
      this.setupInterval()
    },

    teardownInterval () {
      if (!this.auto) return
      if (this.interval) clearInterval(this.interval)
    },

    stateCode (pos, infront) {
      return pos + (infront ? 3 : 0)
    },

    rotateBoxesLeft () {
      const [a, b, c] = this.boxes
      this.boxes = [b, c, a]
    },

    rotateBoxesRight () {
      const [a, b, c] = this.boxes
      this.boxes = [c, a, b]
    },

    nextImage () {
      this.nextii()
      this.primebox(2)
      const [a, b, c] = this.boxes
      this.boxStates[c] = this.stateCode(1, true)
      this.boxStates[b] = this.stateCode(0, true)
      this.boxStates[a] = this.stateCode(2, false)
      this.rotateBoxesLeft()
    },

    prevImage () {
      this.previi()
      this.primebox(0)
      const [a, b, c] = this.boxes
      this.boxStates[a] = this.stateCode(1, true)
      this.boxStates[b] = this.stateCode(2, true)
      this.boxStates[c] = this.stateCode(0, false)
      this.rotateBoxesRight()
    }
  }
}
</script>

<style lang="less" scoped>
@import "../css/globals.less";

@keyframes kenburns {
  100% {
    transform: scale(1.3);
    animation-timing-function: linear;
  }
}

.slider {
  position: relative;

  width: 100%;
  height: 70vh;
  overflow: hidden;
}

.slider .imgbox {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.slider .imgbox {
  background-size: cover;
  background-position: center;
  z-index: 99;
  overflow: hidden;
}

.slider .imgbox .img {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.slider .imgbox .img.animate {
  animation: kenburns 18s infinite alternate;
}

.slider .animateleft {
  transition: left 1s ease-in-out;
}

.imgbox.moveleft {
  left: -100%;
}

.imgbox.moveright {
  left: 100%;
}

.imgbox.movecentre {
  left: 0%;
}

.imgbox.behind {
  z-index: 99;
}

.imgbox.infront {
  z-index: 100;
}

.slider .button {
  position: absolute;
  top: 70%;
  width: 40pt;
  height: 40pt;
  border-radius: 20pt;
  line-height: 40pt;
  font-family: @serif-font;
  text-align: center;
  font-size: 20pt;
  border: 0px solid;
  background-color: black;
  opacity: 0.5;
  color: white;
  z-index: 200;
  cursor: pointer;
}

.spinner {
  position: absolute;
  left: 0;
  right: 0;
  top: 40%;
  text-align: center;
  z-index: 0;
  color: white;
}

.slider .button:hover {
  opacity: 0.7;
}

.slider .left {
  left: 30pt;
}

.slider .right {
  right: 30pt;
}
</style>


// WEBPACK FOOTER //
// src/components/Slider.vue